import { RouteConfig } from "vue-router";
import ROUTES from "../routes";

export const EditorRoutes: Array<RouteConfig> = [
  {
    path: "/editor/:siteId?",
    name: ROUTES.EDITOR,
    component: () =>
      import(
        /* webpackChunkName: 'editor' */
        /* webpackPrefetch: true */
        "../../view/wrappers/editor.vue"
      ),
  },
];
